import React from 'react';
import { ThemeProvider } from 'styled-components';
import { theme } from 'theme';
import { openAuthenticationWindowAction } from 'coral-utility';
import { animated, useSpring } from 'react-spring';
import { officialUseOnly, disclaimer } from 'view/landing/utils/disclaimer';
import LandingIcon from 'view/landing/landingIcon';

import {
  StyledBackground,
  StyledHeader,
  StyledRow,
  StyledTitle,
  StyledLogoContainer,
  StyledLoginContainer,
  StyledTextWrapper,
  StyledHeaderDisclaimer,
  StyledHR,
  StyledLink,
  StyledDisclaimerFooter,
  StyledDisclaimer,
} from './styled-landing';

interface IFCProps {
  state: object;
  openAuthenticationWindowAction: typeof openAuthenticationWindowAction;
}

export const Landing: React.FC<IFCProps> = props => {
  const fadeIn = useSpring({ from: { opacity: 0 }, to: { opacity: 1 }, delay: 100 });

  return (
    <ThemeProvider theme={theme}>
      <StyledBackground>
        <animated.div style={fadeIn} className="dmamc-animated-container">
          <StyledRow>
            <div style={{ display: 'flex', width: '100%', maxWidth: '1600px' }}>
              <StyledLogoContainer>
                <LandingIcon animationClassName="dmamc-animated-logo" />
              </StyledLogoContainer>
              <StyledLoginContainer>
                <StyledTextWrapper>
                  <StyledHeader>
                    <StyledTitle>Instrument Library</StyledTitle>
                  </StyledHeader>
                  <StyledHeaderDisclaimer>{officialUseOnly}</StyledHeaderDisclaimer>
                  <StyledHR />
                  <div style={{ display: 'flex', width: '100%', justifyContent: 'flex-end' }}>
                    <StyledLink
                      onClick={() =>
                        props.openAuthenticationWindowAction(
                          `${process.env.REACT_APP_API_URI}/auth/login?client_id=${process.env.REACT_APP_CLIENT_ID}`
                        )
                      }
                    >
                      <span>Login with Core</span>
                    </StyledLink>
                  </div>
                </StyledTextWrapper>
              </StyledLoginContainer>
            </div>
          </StyledRow>
          <StyledDisclaimerFooter>
            <StyledDisclaimer>{disclaimer}</StyledDisclaimer>
          </StyledDisclaimerFooter>
        </animated.div>
      </StyledBackground>
    </ThemeProvider>
  );
};

export default Landing;
